var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusReturn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99952 3.01338V0.499867C5.99943 0.223713 5.77552 -8.78654e-05 5.49936 2.58787e-08C5.35774 2.9323e-05 5.2228 0.060147 5.12799 0.165353L0.627974 5.1654C0.463412 5.34868 0.45682 5.62449 0.612476 5.81542L5.11252 11.3154C5.28737 11.5292 5.60237 11.5607 5.81612 11.3858C5.9319 11.2911 5.9992 11.1495 5.99952 10.9999V8.50843C9.94957 8.63693 12.4146 10.3254 13.5256 13.6585C13.5938 13.8624 13.7846 13.9999 13.9996 14C14.0266 14.0001 14.0535 13.9979 14.0801 13.9935C14.322 13.954 14.4996 13.7451 14.4996 13.5C14.4996 7.61191 10.9551 3.28637 5.99952 3.01338ZM5.49951 7.49991C5.22335 7.49991 4.99949 7.72377 4.99949 7.99992V9.59993L1.65797 5.51538L4.99952 1.80286V3.49986C4.99952 3.77602 5.22338 3.99987 5.49954 3.99987C9.42958 3.99987 12.3706 6.71941 13.2376 10.8689C11.6281 8.63093 9.03655 7.49991 5.49951 7.49991Z",
    fill: "#EA8612"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusReturn);
export default __webpack_public_path__ + "static/media/status-return.6accec8611c3a5a4462e5385ff87d6f8.svg";
export { ForwardRef as ReactComponent };